import React from 'react';
import { Breadcrumb as RBBreadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Breadcrumbs.scss';

interface IBreadcrumbItemProps {
  active?: boolean;
  children?: JSX.Element | JSX.Element[] | string;
  target: string;
}

export const BreadcrumbItem = ({ children, active, target }: IBreadcrumbItemProps) => {
  return (
    <RBBreadcrumb.Item linkAs={Link} active={active} linkProps={{ to: target }}>
      {children}
    </RBBreadcrumb.Item>
  );
};

interface IBreadcrumbsProps {
  children?: JSX.Element | JSX.Element[];
}

export const Breadcrumbs = ({ children }: IBreadcrumbsProps) => {
  return <RBBreadcrumb className="PraktioBreadcrumb">{children}</RBBreadcrumb>;
};
